import { formatTimeString } from 'main/ui/slider/util'
import { IFilters } from 'main/util/search'
import * as React from 'react'
import { TFunction, useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { i18nKeyPrefix } from '../../../../i18n'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS-PICK-UP`

// @flow
export default function PickUpHoursFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const isActive = !!(filters.pickUpStartsAt || filters.pickUpEndsAt)

  return (
    <div data-pendo="pickUpFilterButton">
      <FilterControl
        isActive={isActive}
        label={isActive ? getActiveLabel(filters, t) : t(`${PRE}-LABEL`)}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}

function getActiveLabel(filters: IFilters, t: TFunction) {
  const pickUpStartsAt = filters.pickUpStartsAt && formatTimeString(filters.pickUpStartsAt)
  const pickUpEndsAt = filters.pickUpEndsAt && formatTimeString(filters.pickUpEndsAt)
  return t(`${PRE}-ACTIVE-LABEL`, { pickUpStartsAt, pickUpEndsAt })
}
